import integrationCatalog, { getCanonicalProviderKey } from "./integrationCatalog";

let cachedOverview = null;
let cachedCards = [];

export const selectIntegrationsState = (state) => state.integrations || {};
export const selectIntegrationsOverview = (state) =>
  selectIntegrationsState(state).overview;
export const selectIntegrationsStatus = (state) =>
  selectIntegrationsState(state).status;
export const selectIntegrationsError = (state) =>
  selectIntegrationsState(state).error;
export const selectIntegrationsMutation = (state) =>
  selectIntegrationsState(state).mutation;

export const selectIntegrationCards = (state) => {
  const overview = selectIntegrationsOverview(state);
  if (overview === cachedOverview) return cachedCards;

  const providers = Array.isArray(overview?.providers) ? overview.providers : [];
  const providerMap = new Map();

  providers.forEach((provider) => {
    const canonicalKey = getCanonicalProviderKey(provider?.key);
    const current = providerMap.get(canonicalKey) || {
      key: canonicalKey,
      connected_groups: 0,
      connections: [],
    };

    const connectionKeys = new Set(
      current.connections.map((connection) => connection.id || connection.group_id)
    );
    (Array.isArray(provider?.connections) ? provider.connections : []).forEach(
      (connection) => {
        const connectionKey = connection.id || connection.group_id;
        if (!connectionKeys.has(connectionKey)) {
          current.connections.push({ ...connection, providerName: provider?.key });
          connectionKeys.add(connectionKey);
        }
      }
    );
    current.connected_groups = new Set(
      current.connections.map((connection) => connection.group_id)
    ).size;
    providerMap.set(canonicalKey, current);
  });

  cachedCards = integrationCatalog.map((catalogItem) => {
    const connectedProvider = providerMap.get(catalogItem.key) || {
      connected_groups: 0,
      connections: [],
    };

    return {
      ...catalogItem,
      connectedGroups: connectedProvider.connected_groups || 0,
      connections: connectedProvider.connections || [],
    };
  });

  cachedOverview = overview;
  return cachedCards;
};

export const selectIntegrationGroups = (state) => {
  const groups = selectIntegrationsOverview(state)?.groups;
  return Array.isArray(groups) ? groups : [];
};

export const selectIntegrationSummary = (state) =>
  selectIntegrationsOverview(state)?.summary || {
    total_groups: 0,
    groups_with_integrations: 0,
    connected_providers: 0,
    total_connections: 0,
  };
